import { Navigate } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MARKET_AUCTIONS } from '@sorare/core/src/constants/__generated__/routes';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const MobileNewSigningsPage = () => {
  return (
    <Navigate
      to={generateSportPath(ANY_SPORT_MARKET_AUCTIONS, {
        sport: Sport.FOOTBALL,
      })}
    />
  );
};

export default MobileNewSigningsPage;
